<template>
  <div class="com-join-step">
    <div v-for="(item, idx) in list" :key="item" :class="$addClass('item', [idx < step, 'on'])">
      <i class="icon" />
      <p>{{ item }}</p>
      <i v-if="idx < 4" class="next" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ComJoinStep',
  props: {
    step: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      list: ['注册卖家账号', '签订入驻协议', '上传公司资质', '填写经营信息', '资格审核，店铺开通']
    }
  }
}
</script>

<style lang="postcss">
.com-join-step {
  width: 1000px;
  height: 90px;
  margin: 20px auto 0 auto;
  background-color: #d1d6de;
  padding: 10px 0;

  .item {
    float: left;
    width: 20%;
    text-align: center;
    position: relative;

    .icon,
    .next {
      display: inline-block;
      width: 43px;
      height: 43px;
      background: url('../assets/images/icon.png') no-repeat;
    }

    .next {
      display: inline-block;
      position: absolute;
      background-position: 0 -86px;
      width: 102px;
      height: 16px;
      top: 17px;
      left: 150px;
    }

    &:nth-child(2) .icon {
      background-position: 0 0;
    }

    &:nth-child(3) .icon {
      background-position: -43px 0;
    }

    &:nth-child(4) .icon {
      background-position: -86px 0;
    }

    &:nth-child(5) .icon {
      background-position: -129px 0;
    }

    &.on {
      color: #fff;

      .next {
        background-position: 0 -103px;
      }

      &:nth-child(1) .icon {
        background-position: 0 -43px;
      }

      &:nth-child(2) .icon {
        background-position: -43px -43px;
      }

      &:nth-child(3) .icon {
        background-position: -86px -43px;
      }
    }
  }
}
</style>
